/**
 * Select browser STT + Polly TTS or Retell speech-to-speech based on env flag.
 */
import { useVoiceConversation, VoiceConversation } from './useVoiceConversation';
import { useRetellVoiceConversation } from './useRetellVoiceConversation';

interface UseAgentVoiceConversationArgs {
  sessionId?: string | null;
  apiBase?: string;
  onTranscript: (text: string) => boolean | Promise<boolean>;
  onCallUpdate?: () => void;
  paused?: boolean;
}

export function useAgentVoiceProvider(): 'retell' | 'browser' {
  const provider = (process.env.REACT_APP_AGENT_VOICE_PROVIDER || 'browser').toLowerCase();
  return provider === 'retell' ? 'retell' : 'browser';
}

export function useAgentVoiceConversation(args: UseAgentVoiceConversationArgs): VoiceConversation {
  const provider = useAgentVoiceProvider();
  const browserVoice = useVoiceConversation({
    onTranscript: args.onTranscript,
    paused: args.paused,
  });
  const retellVoice = useRetellVoiceConversation({
    sessionId: args.sessionId ?? null,
    apiBase: args.apiBase,
    onCallUpdate: args.onCallUpdate,
    paused: args.paused,
  });

  return provider === 'retell' ? retellVoice : browserVoice;
}

export type { VoiceConversation };
